BaseLayer = require './base-layer'

module.exports = App.ImageLayerComponent = BaseLayer.extend
  leafletRequiredOptions: [
    'imageUrl'
    'bounds'
  ]
  leafletOptions: [
    'attribution'
    'opacity'
  ]
  leafletProperties: [
    'url'
    'opacity'
  ]
  createLayer: ->
    @L.imageOverlay.apply @L, @get('requiredOptions').concat([ @get('options') ])